import { render } from "./ClassicLayout.vue?vue&type=template&id=2f6ef82d"
import script from "./ClassicLayout.vue?vue&type=script&lang=js"
export * from "./ClassicLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/ClassicLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f6ef82d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f6ef82d', __exports__)) {
    api.reload('2f6ef82d', __exports__)
  }
  
  module.hot.accept("./ClassicLayout.vue?vue&type=template&id=2f6ef82d", () => {
    api.rerender('2f6ef82d', render)
  })

}


export default __exports__